
import { all, takeEvery } from 'redux-saga/effects'

import appSaga from './appSaga'
import loginSaga from '../../pages/login/loginSaga'
import transcriptViewerSaga from '../../pages/transcript-viewer/transcriptViewerSaga'

let middleware = [];
middleware = middleware.concat(appSaga);
middleware = middleware.concat(loginSaga);
middleware = middleware.concat(transcriptViewerSaga);

export default function* root() {
  let sagas = [];
  for (const ii in middleware) {
    const [key, fun] = middleware[ii];
    if (Array.isArray(key)) {
      for (const jj in key) {
        sagas.push(yield takeEvery(key[jj], fun));
      }
    } else {
      sagas.push(yield takeEvery(key, fun));
    }
  }

  yield all(sagas);
}
